// Global.ts

// Definição dos tipos para as chaves permitidas
type StatusGlobalKey = 'loading' | 'dashboard' | 'page' | 'page_id' | 'page_sub' | 'recover_access' | 'user_name' | 'user_file';

// Tipo para as callbacks registradas
type StatusCallback = (value: boolean | string | number) => void;

// Interface para os status globais
interface IStatusGlobal {
    loading        : boolean;
    dashboard      : boolean;
    page           : string;
    page_id        : number;
    page_sub       : string;
    recover_access : boolean;
    user_name      : string;
    user_file      : string;
}

// Interface para os callbacks de notificação
interface INotifyStatusGlobal {
    loading        : StatusCallback[];
    dashboard      : StatusCallback[];
    page           : StatusCallback[];
    page_id        : StatusCallback[];
    page_sub       : StatusCallback[];
    recover_access : StatusCallback[];
    user_name      : StatusCallback[];
    user_file      : StatusCallback[];
}

const StatusGlobal: IStatusGlobal = {
    loading        : false,
    dashboard      : false,
    page           : 'index',
    page_id        : 0,
    page_sub       : 'reports',
    recover_access : false,
    user_name      : localStorage.getItem('user_name') || '',
    user_file      : localStorage.getItem('user_file') || ''
};

const NotifyStatusGlobal: INotifyStatusGlobal = {
    loading        : [],
    dashboard      : [],
    page           : [],
    page_id        : [],
    page_sub       : [],
    recover_access : [],
    user_name      : [],
    user_file      : []
};

export function SetStatusGlobal(key: StatusGlobalKey, value: IStatusGlobal[StatusGlobalKey]): void {
    (StatusGlobal as Record<StatusGlobalKey, IStatusGlobal[StatusGlobalKey]>)[key] = value;
    NotifyStatusGlobal[key].forEach(element => {
        element(value);
    });
}

export function GetStatusGlobal(key: StatusGlobalKey): IStatusGlobal[StatusGlobalKey] {
    return StatusGlobal[key];
}

export function RegisterStatusGlobal(key: StatusGlobalKey, callback: StatusCallback): void {
    NotifyStatusGlobal[key].push(callback);
}

export function UnRegisterStatusGlobal(key: StatusGlobalKey, callback: StatusCallback): void {
    if (NotifyStatusGlobal[key].length > 0) {
        NotifyStatusGlobal[key] = NotifyStatusGlobal[key].filter((item) => {
            return item !== callback;
        });
    }
}